import gql from 'graphql-tag';

export const GetPlanTemplates = gql`
    query GetPlanTemplates($siteId: SiteId!) {
        finance {
            planTemplates(siteId: $siteId) {
                v3 {
                    templates {
                        name
                        templateId
                        pricingGroupId
                        billingFrequency
                        tuitionIds
                        feeIds
                        discountIds
                    }
                }
            }
        }
    }
`;

export const SavePlanTemplate = gql`
    mutation SavePlanTemplate(
        $siteId: SiteId!
        $name: String!
        $templateId: PlanTemplateId
        $pricingGroupId: PricingGroupId
        $billingFrequency: String!
        $tuitionIds: [SessionId!]!
        $feeIds: [ProductId!]!
        $discountIds: [DiscountPresetId!]!
    ) {
        finance {
            planTemplates(siteId: $siteId) {
                v3 {
                    save(
                        name: $name
                        templateId: $templateId
                        pricingGroupId: $pricingGroupId
                        billingFrequency: $billingFrequency
                        tuitionIds: $tuitionIds
                        feeIds: $feeIds
                        discountIds: $discountIds
                    ) {
                        name
                        templateId
                        pricingGroupId
                        billingFrequency
                        tuitionIds
                        feeIds
                        discountIds
                    }
                }
            }
        }
    }
`;
